import { useState } from "react";
import "./ContactForm.css";
import axios from "axios";

type EmailState = "none" | "sent" | "success" | "failed";

function ContactForm() {
  const [mailState, setMailState] = useState<EmailState>("none");

  return (
    <form
      className="contact-form"
      onSubmit={(e) => {
        e.preventDefault();
        if (e.currentTarget.checkValidity()) {
          const formData = Object.values(e.currentTarget).reduce(
            (accum, current) => {
              if (current?.name) {
                accum[`${current?.name}`] = current.value;
              }
              return accum;
            },
            {}
          );

          setMailState("sent");
          axios
            .post("/sendmail", formData)
            .then((res) => {
              setMailState("success");
              console.log("message sent", res);
            })
            .catch((err) => {
              setMailState("failed");
              console.log("message not sent", err);
            });
        }
      }}
    >
      <div className="d-block">
        <label htmlFor="fullname" aria-required>
          Name
        </label>
        <input
          type="text"
          name="fullname"
          id="fullname"
          className="form-control"
          placeholder="Full Name"
          required
        />
      </div>
      <div className="d-block">
        <label htmlFor="email" aria-required>
          Email Address
        </label>
        <input
          type="email"
          name="email"
          id="email"
          className="form-control"
          placeholder="Email Address"
          required
        />
      </div>
      <div className="d-block">
        <label htmlFor="phone" aria-required>
          Phone
        </label>
        <input
          type="text"
          name="phone"
          id="phone"
          className="form-control"
          placeholder="Phone Number"
        />
      </div>
      <div className="d-block">
        <label htmlFor="message" aria-required>
          Message
        </label>
        <textarea
          name="message"
          id="message"
          rows={5}
          className="form-control"
          placeholder="Message..."
          required
        ></textarea>
      </div>
      <div className="d-block">
        <button
          type="submit"
          className={`btn ${mailState} d-flex justify-content-center form-control`}
        >
          {mailState === "none" ||
          mailState === "success" ||
          mailState === "failed" ? (
            "Submit"
          ) : (
            <div className="spinner-border text-dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </button>
      </div>
    </form>
  );
}

export default ContactForm;
